import React, { useEffect, useState } from "react";
import s from "./TableWrapper.module.scss";
import Filters from "../Filters";
import PhoneNumberTable from "../PhoneNumberTable";
import useSWR from "swr";
import {
  parseClientError,
  swrFetcher,
} from "../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import { PaginatedGetAssignedNumbersType } from "../../../../../../libs/Utils/Types/NumberManagement";

function TableWrapper() {
  const token = UseAuthToken();
  const [search, setSearch] = useState<string>();
  const [page, setPage] = useState<number>(1);
  const [unauthorized, setUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [status, setStatus] = useState<
    "" | "disabled" | "active" | "unassigned"
  >("");
  const handlePage = (page: number, pageSize: number) => {
    setPage(page);
    setPageSize(pageSize);
  };
  const { data, isLoading, error, mutate } = useSWR<
    PaginatedGetAssignedNumbersType,
    any,
    any
  >(
    token
      ? [
          "api/admin/phone-numbers",
          token,
          {
            page,
            limit: pageSize,
            search: search,
            ...(status && { status: status }),
          },
        ]
      : null,
    swrFetcher,
  );
  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setUnauthorized(true);
      } else {
        setUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setUnauthorized(false);
    }
  }, [error]);
  return (
    <div className={s.wrapper}>
      <div className={s.filterWrapper}>
        <Filters
          handleTableSearch={setSearch}
          pageSize={pageSize}
          totalDocs={data?.pagination.totalItems || 1}
          handlePageChange={handlePage}
          handleStatus={setStatus}
        />
      </div>
      <PhoneNumberTable
        data={data?.data || []}
        isLoading={isLoading}
        unauthorized={unauthorized}
        mutate={mutate}
      />
    </div>
  );
}

export default TableWrapper;
